import { Combobox } from "@/components/combobox";

import type { useGdsOffices } from "../api/use-gds-offices";

export type GdsOffice = NonNullable<ReturnType<typeof useGdsOffices>["data"]>[number];

/** Le nom du point de vente d'abord, le code Amadeus derrière : c'est ainsi qu'on le cherche. */
export function officeLabel(office: GdsOffice): string {
  return office.name ? `${office.name} (${office.amadeusOfficeId})` : office.amadeusOfficeId;
}

interface OfficeComboboxProps {
  offices: GdsOffice[];
  /** `TravelAgencyOffice.id` of the selected office. */
  value: number | null;
  onChange: (officeId: number | null) => void;
  placeholder?: string;
  /** Omit to forbid going back to « Aucun ». */
  unselectLabel?: string;
  disabled?: boolean;
  className?: string;
}

/** Office ID picker, searchable by name and Amadeus office ID. */
export function OfficeCombobox({
  offices,
  value,
  onChange,
  placeholder,
  unselectLabel,
  disabled,
  className = "w-full",
}: OfficeComboboxProps) {
  return (
    <Combobox
      className={className}
      items={offices}
      value={offices.find((office) => office.id === value) ?? null}
      onChange={(office) => onChange(office?.id ?? null)}
      getKey={(office) => office.id}
      getLabel={officeLabel}
      getSearchValue={(office) => `${office.amadeusOfficeId} ${office.name ?? ""}`}
      ariaLabel="Office GDS"
      placeholder={placeholder}
      unselectLabel={unselectLabel}
      searchPlaceholder="Rechercher un office..."
      emptyMessage="Aucun office trouvé"
      disabled={disabled}
    />
  );
}
